import React from "react";
import { useNavigate } from "react-router-dom";
import { Page, Card, BlockStack, Text, Layout, InlineGrid, Box, InlineStack, Button } from "@shopify/polaris";
import Placeholder from "../components/common/Placeholder";
import { useDispatch, useSelector } from "react-redux";
import { createUserSubscriptionAsync } from "../redux/userOnboarding";
import { getAllUserOnboarding } from "../redux/userOnboarding/slice";

const PricingPlanPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isUserSubscriptionLoading, isSubscription } = useSelector(getAllUserOnboarding);

    const rows = [
        ['✅ Manual Price Updates'],
        ['✅ Automatic Price Updates'],
        ['✅ Metafield-Based Control'],
        ['✅ Update History Logs'],
        ['✅ Smart Automation'],
        ['✅ Priority Support'],
    ];

    const handleCreateUserSubscription = () => {
        dispatch(createUserSubscriptionAsync({}));
    };

    return (
        <Page title="Pricing Plan" backAction={{ content: 'Back', onAction: () => navigate('/') }}>
            <Layout sectioned>
                <Layout.Section>
                    <InlineGrid gap="400" columns={3}>
                        <Card>
                            <BlockStack gap="400">
                                <BlockStack gap="200" align="start">
                                    <Text as="h3" variant="headingLg">
                                        Basic Plan
                                    </Text>
                                    <Text as="p" variant="bodySm" tone="subdued">
                                        Automate your gold pricing with live updates.
                                    </Text>
                                </BlockStack>
                            </BlockStack>
                            <InlineStack blockAlign="end" gap="100" align="start">
                                <Text as="h2" variant="heading2xl">
                                    $2.99
                                </Text>
                                <Box paddingBlockEnd="200">
                                    <Text variant="bodySm">/ month</Text>
                                </Box>
                            </InlineStack>
                            <Text as="p" variant="bodySm">
                                7 days free trial
                            </Text>
                            <Placeholder padding="5px var(--p-space-100)" />
                            <BlockStack gap="200" align="start">
                                {rows.map((row, index) => (
                                    <Text as="p" key={index}>
                                        {row[1]} {row[0]}
                                    </Text>
                                ))}
                            </BlockStack>
                            <Placeholder padding="5px var(--p-space-100)" />
                            <InlineStack blockAlign="end" gap="100" align="center">
                                <Button onClick={handleCreateUserSubscription} loading={isUserSubscriptionLoading} disabled={isSubscription} variant="primary">
                                    {isSubscription ? 'Subscribed' : 'Get Started'}
                                </Button>
                            </InlineStack>
                        </Card>
                    </InlineGrid>
                </Layout.Section>
            </Layout>
        </Page>
    );
};

export default PricingPlanPage;